import { APP_CONSTANTS } from 'src/app/constants/constants';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-advisor-profile-details',
	templateUrl: './advisor-profile-details.component.html',
	styleUrls: ['./advisor-profile-details.component.scss']
})
export class AdvisorProfileDetailsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() data: any;
	@Output() profileClosed = new EventEmitter<any>();

	base_url: any = environment.apiEndpoint + "/";

	constructor(
		public commonService: CommonService,
		private datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.changeTab(this.profile_tabs[0]);
		this.getProfileData();
	}

	profile_data: any;
	profile_data_loaded: boolean = false;
	getProfileData() {
		this.profile_data_loaded = false;
		this.commonService.getData('/advisordetails/?id=' + this.data.id).subscribe(
			(res: any) => {
				this.profile_data = res;
				this.profile_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		  );
	}

	close() {
		this.profileClosed.emit("Closed");
	}

	profile_fields_data: any = [
		{
			name: "Book of  Business",
			fields: [
				{
					name: "Total Clients",
					key: "total_clients",
					type: "number"
				},
				{
					name: "AUM Reported(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "aum_self_reported",
					type: "number"
				},
				{
					name: "Attrition AUM(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "attrition_aum",
					type: "number"
				},
				{
					name: "Net AUM(" + APP_CONSTANTS.CURRENCY_SYMBOL + ")",
					key: "net_new_aum",
					type: "number"
				},
				{
					name: "Products Sold",
					key: "sales",
					type: "number"
				},
			]
		},
		{
			name: "Personal Information",
			fields: [
				{
					name: "Advisor ID",
					key: "advisor_id",
					type: "text"
				},
				{
					name: "Date of Birth",
					key: "date_of_birth",
					type: "date"
				},
				{
					name: "Gender",
					key: "gender",
					type: "text"
				},
			]
		},
		{
			name: "Contact Information",
			fields: [
				{
					name: "Email ID",
					key: "email",
					type: "text"
				},
				{
					name: "Phone Number",
					key: "phone_number",
					type: "text"
				},
			]
		},
		{
			name: "Primary Address Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "city",
					type: "text"
				},
				{
					name: "State",
					key: "state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "region",
					type: "text"
				},
			]
		},
		{
			name: "Address 2 Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_2_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_2_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "address_2_city",
					type: "text"
				},
				{
					name: "State",
					key: "address_2_state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "address_2_zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "address_2_region",
					type: "text"
				},
			]
		},
		{
			name: "Address 3 Information",
			fields: [
				{
					name: "Address Line 1",
					key: "address_3_line_1",
					type: "text"
				},
				{
					name: "Address Line 2",
					key: "address_3_line_2",
					type: "text"
				},
				{
					name: "City",
					key: "address_3_city",
					type: "text"
				},
				{
					name: "State",
					key: "address_3_state",
					type: "text"
				},
				{
					name: "Zip Code",
					key: "address_3_zip_code",
					type: "text"
				},
				{
					name: "Region",
					key: "address_3_region",
					type: "text"
				},
			]
		},
		{
			name: "Experience/Qualification",
			fields: [
				{
					name: "Total Experience",
					key: "total_experience",
					type: "text"
				},
				{
					name: "States Registered",
					key: "states_registered",
					type: "array"
				},
				{
					name: "No. of Licences",
					key: "total_license_list",
					type: "array"
				},
				{
					name: "No. of Certificates",
					key: "certificate_list",
					type: "array"
				},
				{
					name: "Professional Associations",
					key: "professional_association_list",
					type: "array"
				},
				{
					name: "Advisor Type",
					key: "advisor_type",
					type: "text"
				},
				{
					name: "Dually Licensed",
					key: "dually_licensed",
					type: "boolean"
				},
				{
					name: "Regulatory Disclosures",
					key: "regulatory_disclosures",
					type: "boolean"
				},
				{
					name: "Year became Representative",
					key: "date_became_representative_year",
					type: "year"
				},
				{
					name: "Sells Insurance Products",
					key: "sells_insurance_products",
					type: "boolean"
				},
				{
					name: "Sells Retirement Products",
					key: "sells_retirement_products",
					type: "boolean"
				},
			]
		},
	];

	profile_tabs: any = [
		{
			name: "Demographic Info",
		},
		{
			name: "Employment Info",
		},
		{
			name: "Services",
		},
		{
			name: "Sales History",
		},
		{
			name: "Coaching Plan",
		},
	];
	profile_tab_selected: any = "";
	changeTab(data) {
		this.profile_tab_selected = data.name;
	}

	getValue(data, key) {
		if (data.type == "text") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.profile_data[key];
			} else {
				return "-";
			}
		} else if (data.type == "boolean") {
			if (this.profile_data[key] && this.profile_data[key] == true) {
				return "Yes";
			} else {
				return "No";
			}
		} else if (data.type == "date") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.datePipe.transform(this.profile_data[key], 'dd MMM yyyy');
			} else {
				return "-";
			}
		} else if (data.type == "year") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.datePipe.transform(this.profile_data[key], 'yyyy');
			} else {
				return "-";
			}
		} else if (data.type == "number") {
			if (this.profile_data[key] != "" && this.profile_data[key] != null) {
				return this.commonService.abbreviateNumber(this.profile_data[key]);
			} else {
				return "-";
			}
		} else if (data.type == "array") {
			if (this.profile_data[key].length > 0) {
				let value: any = this.profile_data[key].length;
				value = value +  "(";
				for (let index = 0; index < this.profile_data[key].length; index++) {
					value =  value  + this.profile_data[key][index];
					if ((index + 1) != this.profile_data[key].length) {
						value = value +  ", "
					}
				}
				value = value +  ")";
				return value;
			} else {
				return "0";
			}
		}
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
		  return null;
		}
		if (num === 0) {
		  return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		  k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		  c =
			k < 1
			  ? num.toFixed(0 + fixed)
			  : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		  d = c < 0 ? c : Math.abs(c),
		  e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	navigateToExternalLink(link) {
		if (link != "" && link != null) {
			window.open(link, "_blank");
		}
	}


}
